// --- Config: Titles mapped to SVG icons ---
const icons = {
  'Keto Granola': `<svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.04 28"><path d="M0 0l1.24 27.43.42.05a67.49 67.49 0 0016.72 0l.42-.05L20.04 0H0zm13.48 20.19c-.35.7-.86 1.29-1.46 1.69-.61.41-1.3.62-2 .62s-1.39-.21-2-.62c-.6-.4-1.11-.99-1.46-1.69-.02-.06-.04-.12-.04-.19s.02-.13.04-.19c.35-.7.86-1.29 1.46-1.69.61-.41 1.3-.62 2-.62s1.39.21 2 .62c.6.4 1.11.99 1.46 1.69.02.06.04.12.04.19s-.02.13-.04.19z" fill="#282828"/></svg>`,
  'Keto Bars': `<svg height=25 width=25 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.58 26.314"><path fill="#282828" d="M8.49 7.474l6.93 8-4.26 7.38-1.01 3.46L0 20.454l2.43-2.51 6.06-10.47zM17.94 11.364l-.02.21-.07.68-.13 1.24-.29 2.76-.78-.9-.35-.41-.35-.39-6.14-7.08-1.02-1.17-.1-.12.09-.11 9.16 5.29zM20.38 4.754l-2.75 4.76-6.93-4 2.75-4.76c.41-.72 1.33-.97 2.05-.55l4.33 2.5c.35.2.59.52.7.91.1.39.05.79-.15 1.14z"/></svg>`,
  'Keto Baking Mixes': `<svg height=25 width=25 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.718 24.145"><path d="M27.717 11.895c0 .12-.65 12.25-12.25 12.25s-12.73-12.11-12.74-12.23c-.02-.14.03-.28.13-.38.09-.1.22-.16.36-.16h24c.14 0 .27.06.37.15.09.1.14.24.13.37zM10.967 9.565c-.08.19-.26.31-.47.31h-2.28c-.12 0-.24-.05-.34-.13l-7.5-7a.396.396 0 01-.1-.15c-.25-.49-.51-1.48.09-2.07.7-.7 1.79-.7 2.49 0 .11.11.59.62 1.27 1.37 1.68 1.82 4.82 5.22 6.73 7.13.14.14.18.35.11.54z" fill="#282828"/></svg>`
};

// --- Action: Inject icons before matching h2s ---
function injectIcons() {
  // Find all h2 elements
  document.querySelectorAll('#__next h2').forEach(h2 => {
    // Get the title of the h2 element
    const title = h2.textContent.trim();
    // If the title is in the icons object and the icon has not been added yet
    if (icons[title] && !h2.dataset.iconAdded) {
      // Create a wrapper for the icon
      const iconWrapper = document.createElement('span');
      iconWrapper.innerHTML = icons[title];
      // Get the svg element
      const svg = iconWrapper.querySelector('svg');
      // Set the width and height of the svg
      svg.setAttribute('width', '27');
      svg.setAttribute('height', '27');
      // Style the icon wrapper
      h2.style.display = 'flex';
      iconWrapper.style.marginRight = '0.5em';
      iconWrapper.style.display = 'flex';
      iconWrapper.style.alignSelf = 'center';
      // Add the icon wrapper to the h2 element
      h2.prepend(iconWrapper);
      // Add a dataset to the h2 element to indicate that the icon has been added
      h2.dataset.iconAdded = 'true';
    }
  });
}

// --- Add more actions here if needed ---
const pageTweaks = [injectIcons];

// --- Observe #__next and run tweaks when content is added ---
const targetNode = document.getElementById('__next');
if (targetNode) {
  const observer = new MutationObserver(() => {
    pageTweaks.forEach(fn => fn());
  });
  observer.observe(targetNode, { childList: true, subtree: true });
}